export const AiChatApp = {
  inputPlaceholder: '给 Pai 发送消息',
  like: '赞',
  dislike: '踩',
}; 